import React from 'react'

const CustomTooltip = (labelText) => ({active, payload, label}) => {
  if (active) {
    if (!payload) {
      payload = []
    }
    return (
      <div className="custom-tooltip">
        <p className="label">{`${label}`}</p>
        <p className="value">{labelText + ': ' + (payload[0] ? payload[0].value : 0)}</p>
      </div>
    )
  }
}

export default CustomTooltip



// WEBPACK FOOTER //
// ./src/elements/tooltip.js